<template>
  <div class="container">
    <HeadComponent/>

    <main>
      <form class="row" @submit.prevent="register">
        <div class="col"></div>
        <div class="col">
          <div class="d-flex flex-column align-items-center justify-content-center">
            <h2>Subscribe</h2>

            <div class="mb-2 ">
              <label for="exampleFormControlInput1" class="form-label">Email address</label>
              <input id="email" class="form-control" type="email" v-model="email" placeholder="name@example.com" required/>
            </div>

            <div class="mb-2">
              <label for="exampleFormControlInput1" class="form-label">Password</label>
              <input id="password" class="form-control" type="password" v-model="password" placeholder="Min 8 characters"
                     required/>
            </div>

            <div class="mb-2">
              <label for="exampleFormControlInput1" class="form-label">User name</label>
              <input id="name" class="form-control" type="text" v-model="name" placeholder="User name" required/>
            </div>

            <div class="mb-3">
              <label for="b_date" class="form-label">Birth date</label>
              <input class="form-control" type="date" v-model="b_date"/>
            </div>

            <button class="btn btn-primary" type="submit">Subscribe</button>
          </div>
        </div>
        <div class="col"></div>
      </form>
    </main>

    <FooterComponent/>
  </div>
</template>

<script>
import {eventBus} from '@/eventBus';

import {registerUser} from '@/services/auth/registerSerevice.js';
import {logout} from '@/services/auth/loginService.js';

import HeadComponent from '@/components/views/head/HeadComponent.vue';
import FooterComponent from "@/components/views/footer/FooterComponent.vue";

export default {
  name: 'RegisterView',
  components: {
    FooterComponent,
    HeadComponent,
  },
  /**
   * Returns an object containing user data and status.
   *
   * @return {Object} An object with the following properties:
   * - email {string}: The email address of the user, initialized as an empty string.
   * - password {string}: The user's password, initialized as an empty string.
   * - name {string}: The user's name, initialized as an empty string.
   * - b_date {string}: The user's birth date, initialized as an empty string.
   * - hasUserData {boolean}: Indicates whether user data has been set, initialized as false.
   */
  data() {
    return {
      email: '',
      password: '',
      name: '',
      b_date: '',
      hasUserData: false,
    };
  },
  /**
   * Lifecycle method triggered after the component is mounted to the DOM.
   * Sets up the necessary state and event listeners for the component.
   * Specifically, it updates the user data and listens for the 'session-updated' event
   * to trigger the updateUserData method.
   *
   * @return {void} Does not return a value.
   */
  mounted() {
    this.updateUserData();
    eventBus.on('session-updated', this.updateUserData);
  },
  /**
   * Lifecycle hook that is called right before the Vue component is unmounted.
   * It cleans up event listeners or other resources to prevent memory leaks.
   *
   * In this method, an event listener for the 'session-updated' event is removed
   * from the event bus to avoid unnecessary updates after the component is destroyed.
   *
   * @return {void} This method does not return a value.
   */
  beforeUnmount() {
    eventBus.off('session-updated', this.updateUserData);
  },
  /**
   * Contains methods for user actions including registration, logout, and updating user data.
   */
  methods: {
    /**
     * Handles the user registration process by calling the `registerUser` method with the provided user details,
     * displaying a success message using SweetAlert upon successful registration, emitting a session update event,
     * and redirecting the user to the specified route. If an error occurs during the process, it will log the error
     * and display an alert notification.
     *
     * @return {Promise<void>} A promise that resolves once the registration process is complete,
     * including SweetAlert confirmation and redirection, or rejects if an error occurs during registration.
     */
    async register() {
      try {
        await registerUser(this.email, this.password, this.name, this.b_date);
        this.updateUserData();

        // Muestra el SweetAlert y espera a que el usuario pulse "Aceptar"
        await this.$swal({
          icon: 'success',
          title: `Welcome ${sessionStorage.getItem('name')}`,
          text: sessionStorage.getItem('message') || 'Login successful.',
          confirmButtonText: 'Accept',
        });

        eventBus.emit('session-updated');

        // Redirige después de cerrar el SweetAlert
        this.$router.push('/links');
      } catch (error) {
        console.error('Error registering:', error);
        alert('Registration failed. Please try again.');
      }
    },
    /**
     * Logs out the current user from the application.
     * This method will perform necessary cleanup and update the user data accordingly.
     *
     * @return {void} No return value.
     */
    logout() {
      logout();
      this.updateUserData();
    },
    /**
     * Displays a success alert using SweetAlert2 to welcome the user after login.
     *
     * @param {string} name - The name of the user to display in the alert title.
     * @param {string} [message] - An optional custom message to display in the alert body. Defaults to 'Login successful.'.
     * @return {void} This method does not return any value.
     */
    sweetShowAlertLogin(name, message) {
      this.$swal({
        icon: 'success',
        title: `Welcome ${name}`,
        text: message || 'Login successful.',
        confirmButtonText: 'Accept',
      });
    },
    /**
     * Updates the user data properties by retrieving values from session storage.
     * The method checks for the existence of a 'name' key in session storage and updates
     * the `hasUserData`, `name`, and `b_date` properties accordingly.
     *
     * @return {void} This method does not return a value.
     */
    updateUserData() {
      this.hasUserData = !!sessionStorage.getItem('name');
      this.name = sessionStorage.getItem('name') || '';
      this.b_date = sessionStorage.getItem('b_date') || '';
    },
  },
};
</script>
